<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 17:57:03
 * @LastEditTime: 2020-09-11 10:22:35
 * @Description: 储罐租借页面
-->
<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索客户..."
        clearable
        icon="ios-search"
        @on-change="searchSacTankRental"
        style="width: 250px; margin-right: auto"
      >
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadSacTankRental"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.AddTankRentalDrawer.openDrawer()"
        >新增储罐租借</Button
      >
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      ></Table>
    </div>
    <AddTankRentalDrawer ref="AddTankRentalDrawer" />
  </div>
</template>

<script>
import AddTankRentalDrawer from "./AddTankRentalDrawer";
import { mapState, mapActions, mapGetters } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";

export default {
  name: "TankRental",
  components: { AddTankRentalDrawer },
  props: {},
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "客户",
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.AddTankRentalDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.customer.name
              ),
            ]);
          },
        },
        {
          title: "公司",
          key: "company",
          render: (h, params) => {
            return h(
              "span",
              params.row.company.abbr
                ? params.row.company.name
                : params.row.company.name
            );
          },
        },
        {
          title: "容量/吨",
          key: "weight",
          align: "center",
        },
        {
          title: "数量/个",
          key: "quantity",
          align: "center",
        },
        {
          title: "金额/元",
          key: "price",
          align: "center",
        },
        {
          title: "借用日期",
          key: "rentalTime",
          align: "center",
          render: (h, params) => {
            return h("span", dayjs(params.row.rentalTime).format("YYYY-MM-DD"));
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
        },
      ],
      tableHeight: 300,
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.tankRental.tankRentalList,
      totalRows: (state) => state.tankRental.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getTankRentalList: "tankRental/getTankRentalListAction",
    }),
    async loadSacTankRental(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15, limit: 15 };
      if (this.searchText) api.searchText = this.searchText;

      try {
        this.tableLoading = true;
        await this.getTankRentalList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSacTankRental: _.debounce(function () {
      this.page = 0;
      this.loadSacTankRental();
    }, 1000),
  },
  created() {
    this.loadSacTankRental();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
